import helper from '@/libs/forms';

export default {
  schema: onSubmit => ({
    fields: [
      helper.social('/myLinkedin', 'linkedin', 'linkedin'),
      helper.social('/myFacebook', 'facebook', 'facebook'),
      helper.social('/myInstagram', 'instagram', 'instagram'),
      helper.social('/myTwitter', 'twitter', 'twitter'),
      helper.submitBtn('Update', null, onSubmit),
    ],
  }),
  formOptions: helper.options('social-', false),
};



// WEBPACK FOOTER //
// ./src/components/profile/sections/profile/social/schema.js